export const SENSITIVE_KEYS = new Set([
    "token",
    "authorization",
    "x-smart-shikka-local-token",
    "x-smart-shikha-local-token",
    "secret",
    "apikey",
    "api_key",
    "apiKey",
    "api-key",
    "api_secret",
    "apisecret",
    "apiSecret",
    "password",
    "passwd",
    "cookie",
    "rawbody",
    "raw_body",
    "rawBody",
    "accesstoken",
    "access_token",
    "accessToken",
    "refreshtoken",
    "refresh_token",
    "refreshToken",
    "privatekey",
    "private_key",
    "privateKey",
    "credential",
    "credentials",
    "idtoken",
    "id_token",
    "idToken",
]);
export function isSensitiveKey(key) {
    return SENSITIVE_KEYS.has(key.toLowerCase());
}
export function redactSensitiveData(value, extraKeys) {
    if (value === null || value === undefined)
        return value;
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean")
        return value;
    if (Array.isArray(value)) {
        return value.map((item) => redactSensitiveData(item, extraKeys));
    }
    if (typeof value === "object") {
        const result = {};
        const extra = new Set(extraKeys?.map((k) => k.toLowerCase()) ?? []);
        for (const [key, val] of Object.entries(value)) {
            if (SENSITIVE_KEYS.has(key.toLowerCase()) || extra.has(key.toLowerCase())) {
                result[key] = "[REDACTED]";
            }
            else {
                result[key] = redactSensitiveData(val, extraKeys);
            }
        }
        return result;
    }
    return value;
}
//# sourceMappingURL=redaction.js.map